import { generateOptions } from "@/pages/DashboardPage";
import { API_URL } from "@/redux-client/api";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import Notification from "../common/Notification";
import Loading from "../common/Loading";
import { rupiahFormat } from "@/helper";

// const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

const RevenueChart = () => {
  
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const [labels, setLabels] = useState([]);
  const [datasets, setDatasets] = useState([]);

  const options = generateOptions({ 
    title: "Grafik Estimasi Omset",
    yAxisTitle: "( x 1000 ) rupiah",
    yAxisStepSize: 2000,
    yAxisMax: 100000
  });
  
  const fetchData = useCallback(async() => {
    const response = await axios.get(`${API_URL}/dashboard/revenue?period=year`);

    const { status, msg } = response.data;
    
    try {
      if(status === 200) {
        const { data } = response.data.message;
        setLabels(data.labels);
        setDatasets(data.datasets);
        setIsLoading(false);
      } else {
				setNotification({
					title: 'Terjadi kesalahan',
					text: msg,
					isError: true,
				});
      };
    } catch (error) {
      console.log(error);
      setIsLoading(false);
			setNotification({
				title: 'Network error!',
				text: 'Terjadi kesalahan. Silahkan coba beberapa saat lagi.',
				isError: true,
			});
		};
  }, []);

  useEffect(() => {
    fetchData();
    return () => {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  return (
    <div className='p-3 bg-white rounded-xl'>
      { isLoading ? 
        <div className="py-10">
          <Loading type="beat-loader" loading={isLoading} size={12} />
        </div>
        : <>
          <Notification notification={notification} className="mt-2" />
          <Line
            options={options}
            data={{
              labels,
              datasets
            }}
          />
          <div className="mt-5 text-sm px-3">
            {datasets.map((item, idx) => {
              const total = item.data.reduce((accumulator, a) => accumulator+a, 0);
              return (
                <div key={`total-sales_${idx}`} className="flex items-center gap-3">
                  <p>- Total Estimasi Omset tahun {item.label}</p>
                  <span>:</span>
                  <p className="font-semibold">{rupiahFormat(total*1000)}</p>
                </div>
              );
            })}
          </div>
        </>
      }
    </div>
  );
};

export default RevenueChart;
